import { defineStore } from 'pinia'
import { ref, shallowRef } from 'vue'

export const useRightSongsDetailStore = defineStore('rightSongsDetailStore', () => {
  const isOpen = ref(false)
  const songData = shallowRef<any>(null)

  const openRightSongsDetail = (song?: any) => {
    if (typeof window !== 'undefined' && window.innerWidth < 768) {
      return
    }
    if (song) {
      songData.value = song
    }
    isOpen.value = true
  }

  const closeLeftSongsDetail = () => {
    isOpen.value = false
    songData.value = null
  }

  return {
    isOpen,
    songData,
    openRightSongsDetail,
    closeLeftSongsDetail
  }
})
